import React from 'react';

import { Card, CardContent, CardHeader, CircularProgress, Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const SendingCalendarInviteModal = styled(Modal)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const SendingCalendarInviteCard = styled(Card)`
    width: 500px;
`;

const SendingCalendarInviteCardHeader = styled(CardHeader)`
    background-color: ${(props) => props.theme.colors.primary};
    color: white;
`;
const SendingCalendarInviteCardContent = styled(CardContent)`
    text-aling: center;
`;
export interface SendingCalendarInviteModalProps {
    open: boolean;
    onClose: () => void;
}

const RosterSendingCalendarInviteModal: React.FC<SendingCalendarInviteModalProps> = (props) => {
    const { t } = useTranslation('roster');

    return (
        <SendingCalendarInviteModal open={props.open} onClose={props.onClose}>
            <SendingCalendarInviteCard>
                <SendingCalendarInviteCardHeader title={t('sending-calendar-invitations')} />
                <SendingCalendarInviteCardContent><span>{t('sending')}</span><CircularProgress /></SendingCalendarInviteCardContent>

            </SendingCalendarInviteCard>
        </SendingCalendarInviteModal>
    );
};

export default RosterSendingCalendarInviteModal;
